/* eslint-disable */
import React, { useState } from "react";
import NavBar from "../../components/shared/NavBar/NavBar";
import styles from "./TermsAndConditions.module.css";
import QuestionIcon from "../../assets/common/question.svg";
import ContactUsCard from "../../components/privacy/ContactUsCard";
import TermsContent from "../../components/privacy/TermsContent";
import BottomNav from "../../components/shared/BottomNav/BottomNav";

export default function TermsAndConditions() {
  // State to manage the visibility of the ContactUsCard
  const [isContactCardVisible, setContactCardVisible] = useState(false);

  return (
    <div className={styles.container}>
      <NavBar />
      <BreadcrumbNav />
      <TermsContent />
      {isContactCardVisible && (
        <div className={styles["contactus-card"]}>
          <ContactUsCard />
        </div>
      )}
      <FloatingIcon
        onClick={() => {
          setContactCardVisible((prev) => !prev);
        }}
      />
    </div>
  );
}

const BreadcrumbNav = () => {
  const date = `Last updated: August 8, 2024`;
  return (
    <div className={styles["breadcrumb"]}>
      <div className={styles["breadcrumb-content"]}>
        <div className={styles["breadcrumb-left"]}>
          <span>Home</span>
          {"  |   "}
          <span className={styles["active-link"]}>Terms of service</span>
        </div>
        <div className={styles["breadcrumb-right"]}>{date}</div>
      </div>
      <hr className={styles["breadcrumb-line"]} />
    </div>
  );
};

const FloatingIcon = ({ onClick }) => {
  return (
    <div className={styles["floating-icon"]} onClick={onClick}>
      <img src={QuestionIcon} alt="Question Icon" />
    </div>
  );
};
